import { useEffect } from 'react';

// Zentraler Body-Scroll-Lock per Modul-Counter.
//
// Jede aktive Hook-Instanz erhoeht den Counter. Erst der erste Aktivator
// snapshottet den Original-Wert von `body.style.overflow` und setzt
// `overflow: hidden`. Beim letzten Cleanup wird der Snapshot exakt
// wiederhergestellt. So koennen mehrere Modals (Beleg-Modal +
// Anfrage-Sidebar) parallel offen sein, ohne dass die Snapshots
// gegenseitig "hidden" als Original speichern und den Body permanent
// locken.
//
// Z-Index-Skala (Stand 2026-05, dokumentiert hier weil hier der zentrale
// Modal-Stack lebt):
//   FAB-Button         z-40
//   Modal (Desktop)    z-50
//   BottomSheet        z-[60] / z-[70]   (Backdrop / Sheet)
//   CartSidebar        z-[80] / z-[90]   (Backdrop / Drawer)

let lockCount = 0;
let originalOverflow: string | null = null;

function acquire(): void {
  if (typeof document === 'undefined') return;
  if (lockCount === 0) {
    originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  lockCount += 1;
}

function release(): void {
  if (typeof document === 'undefined') return;
  if (lockCount === 0) return;
  lockCount -= 1;
  if (lockCount === 0) {
    document.body.style.overflow = originalOverflow ?? '';
    originalOverflow = null;
  }
}

export function useBodyScrollLock(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    acquire();
    return release;
  }, [active]);
}
